export function getFullname(last_name, first_name) {
  const userInfo = sessionStorage.getItem('userInfo')
  const countryCode = JSON.parse(userInfo)?.userInfo?.country_code
  if (countryCode === '0082' || countryCode === '0086') {
    return (last_name || '') + (first_name || '')
  } else {
    return (first_name || '') + ' ' + (last_name || '')
  }
}
